import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

type AbortPinPostProps = {
  id: number;
  ledgerId?: number;
  isSession?: boolean;
};

const useAbortPinPost = () => {
  const { t } = useTranslation();
  const branchId = useBranchId();
  const mutation = useMutation({
    mutationFn: ({
      id,
      isSession = false,
    }: AbortPinPostProps): Promise<void> => {
      if (isSession) {
        return post2(
          `/internal/secure/pos/v1/payments/pos-terminal-abort/session/${id}/${branchId}`
        );
      } else {
        return post2(
          `/internal/secure/pos/v1/payments/pos-terminal-abort/order/${id}/${branchId}`
        );
      }
    },
    onSuccess: () => {
      toast.success(t("success.delete"));
    },
  });

  return mutation;
};

export default useAbortPinPost;
